import styled from '@emotion/styled';
import { css, keyframes } from '@emotion/react';
import { COLORS3 as COLORS, SPACING } from '../../styles/emotion';

const loadingSwipe = (animationWidth: number) => keyframes`
  0% {
    background-position: -${animationWidth / 2}px 0;
  }
  100% {
    background-position: ${animationWidth / 2}px 0;
  }
`;

export const Loader = styled.div<{
  animationWidth: number;
  maxWidth?: number;
}>`
  border-radius: ${SPACING.XS};
  width: 100%;
  ${({ maxWidth }) => (maxWidth ? `max-width: ${maxWidth}px` : null)};
  background: linear-gradient(
    to right,
    var(--background-container, ${COLORS.BLACK_005}) 8%,
    var(--background-screen, ${COLORS.WHITE_100}) 18%,
    var(--background-container, ${COLORS.BLACK_005}) 33%
  );
  background-size: ${({ animationWidth }) => `${animationWidth}px 100px`};
  ${({ animationWidth }) => css`
    animation: ${loadingSwipe(animationWidth)} 2s infinite ease-out;
  `}
`;

export const InvisibleText = styled.span`
  opacity: 0;
`;
